import { ApplicablePoint } from '@/models/point/applicable-point'
import { ApplicablePointQuery, PointService } from '@/services/point'
import { Either } from 'fp-ts/lib/Either'

export interface ApplicablePointRepository {
  get(query: Query): Promise<Either<Error, ApplicablePoint>>
}

export class ApiApplicablePointRepository implements ApplicablePointRepository {
  static create(): ApplicablePointRepository {
    return new ApiApplicablePointRepository(PointService.createDefault())
  }

  constructor(private readonly client: PointService) { }

  async get(query: Query): Promise<Either<Error, ApplicablePoint>> {
    const result = await this.client.getApplicable(query)

    return result.map(raw =>
      new ApplicablePoint(raw.applicable)
    )
  }
}
/**
 * serviceへ直接依存させないための暫定処置.
 *
 * APIへ渡すパラメータとリポジトリとして請求すべきパラメータが一致しなくなったら、
 * Queryをaliasではなく独自定義にする形で適宜吸収 or 拡張する.
 */
export type Query = ApplicablePointQuery
